export const tagColors = {
  php: "bg-purple-400 text-white",
  javascript: "bg-yellow-400 text-black",
  typescript: "bg-blue-600 text-white",
  reactjs: "bg-[#61DAFB] text-black",
  nextjs: "bg-black text-white",
  tailwindcss: "bg-teal-400 text-white",
  docker: "bg-blue-500 text-white",
  symfony: "bg-black text-white",
  symfonyux: "bg-black text-white",
  heroui: "bg-indigo-400 text-white",
  materialui: "bg-[#007FFF] text-white",
};